import store from '../store/main'
// import Login from '../views/Login.vue'
import LogOut from '../views/LogOut.vue'
// import SignIn from '../views/SignIn/SignUp.vue' //first step
// import SignUpBusiness from '../views/SignIn/BusinessForm.vue'
// import SignUpUser from '../views/SignIn/UserForm.vue'
import ActivateAccount from '../views/SignIn/ActivateAccount.vue'
import EnterPhone from '../views/EnterPhone.vue'
import TripCreate from '../views/Trips/Create.vue'
import ProposedCreate from '../views/Trips/Forms/ProposedTripForm'
import ProposedEdit from '../views/Trips/Forms/ProposedTripForm'
import PlannedCreate from '../views/Trips/Forms/PlannedTripForm'
import MyTrips from '../views/Trips/MyTrips.vue'
import TripDetail from '../views/Trips/Detail.vue'
import Search from '../views/Trips/Search.vue'
import Spinner from '../components/Loader.vue'
import EmailLinks from '../views/EmailLinks.vue'
import RenewTrip from '../views/RenewTrip.vue'

import PasswordRecoveryCreate from "../views/PasswordRecovery/Create";
import PasswordRecoveryReset from "../views/PasswordRecovery/ResetForm";
import Profile from "../views/Profile";
import MainLayout from '../MainLayout';
import Home from "../views/Home/Home";
import FAQ from "../views/FAQ/FAQ";
import AboutUs from "../views/About/About";
import Media from "../views/Media/Media";
import Support from "../views/Support/Support";
import TermsOfService from "../views/TermsOfService/TermsOfService";
import BrokerTermsOfService from "../views/TermsOfService/BrokerTermsOfService";
import OperatorTermsOfService from "../views/TermsOfService/OperatorTermsOfService";
import PrivacyPolicy from "../views/PrivacyPolicy/PrivacyPolicy";
import FirstTimeFlyer from "../views/FirstTimeFlyer/FirstTimeFlyer";
import SearchIframe from '../views/Trips/Iframe.vue'

let iframe = {
    path: '/trip/search/iframe',
    name: 'TripSearchIframe',
    component: SearchIframe
};

let entryUrl = null;
const guard = async(to, from, next) => {
    if (store.state.auth) {
        if (entryUrl) {
            const url = entryUrl;
            entryUrl = null;
            return next(url); // goto stored url
        } else {
            return next(); // all is fine
        }
    }
    store.dispatch('users/getUser').then(() => {
        if (store.state.auth) {
            next();
        } else {
            entryUrl = to.path; // store entry url before redirect
            next('/login');
        }
    });
};

/* {
            path: '/',
            redirect: { name: 'TripSearch' }
        }, */

let appPages = {
    path: '/',
    component: MainLayout,
    name: 'MainLayout',
    children: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/faq',
            name: 'FAQ',
            component: FAQ
        },
        {
            path: '/about-us',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/media',
            name: 'Media',
            component: Media
        },
        /* {
            path: '/signin',
            name: 'SignIn',
            component: SignIn
        }, */
        {
            path: '/logout',
            name: 'LogOut',
            component: LogOut
        },
        {
            path: 'support',
            name: 'Support',
            component: Support
        },
        {
            path: 'terms-of-service',
            name: 'TermsOfService',
            component: TermsOfService
        },
        {
            path: 'broker-terms-of-service',
            name: 'BrokerTermsOfService',
            component: BrokerTermsOfService
        },
        {
            path: 'operator-terms-of-service',
            name: 'OperatorTermsOfService',
            component: OperatorTermsOfService
        },
        /* {
            path: '/signin/user',
            name: 'SignUpUser',
            component: SignUpUser
        },
        {
            path: '/signin/business',
            name: 'SignUpBusiness',
            component: SignUpBusiness
        },  */
        {
            path: '/activate/:token',
            name: 'ActivateAccount',
            component: ActivateAccount,
        },
        {
            path: '/enter-phone/:hash',
            name: 'EnterPhone',
            component: EnterPhone,
        },
        {
            path: 'trip/search',
            name: 'TripSearch',
            component: Search
        },
        {
            path: '/trip/create/proposed',
            name: 'ProposedTripCreate',
            component: ProposedCreate,
            beforeEnter: guard,
            meta: {
                edit: false
            }
        },
        {
            path: '/trip/edit/proposed',
            name: 'ProposedTripEdit',
            component: ProposedEdit,
            beforeEnter: guard,
            meta: {
                edit: true
            }
        },
        {
            path: '/trip/create/planned',
            name: 'PlannedTripCreate',
            component: PlannedCreate,
            beforeEnter: guard,
        },
        {
            path: '/trip/create',
            name: 'TripCreate',
            component: TripCreate,
            beforeEnter: guard,
        },
        {
            path: '/login',
            name: 'Login',
            beforeEnter: () => {
                window.location.replace(process.env.VUE_APP_HOME_PAGE)
            }
        },
        /* {
          path: '/conversations',
          name: 'ConversationsList',
          component: ConversationList,
          beforeEnter: guard,
        },
        {
          path: '/trip/:trip/conversation/messages',
          name: 'MessageList',
          component: MessagesList,
          beforeEnter: guard,
        },*/
        {
            path: '/password-recovery',
            name: 'PasswordRecoveryCreate',
            component: PasswordRecoveryCreate
        },
        {
            path: '/password-recovery/:token',
            name: 'PasswordRecoveryReset',
            component: PasswordRecoveryReset
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            beforeEnter: guard,
        },
        {
            path: '/my-trips',
            name: 'MyTrips',
            component: MyTrips,
            beforeEnter: guard,
        },
        {
            path: '/trip/:trip/detail',
            name: 'TripDetail',
            component: TripDetail,
            // beforeEnter: guard,
        },
        {
            path: '/spinner',
            name: 'Spinner',
            component: Spinner,
            // beforeEnter: guard,
        },
        {
            path: '/email-links/:action/:hash',
            name: 'EmailLinks',
            component: EmailLinks
        },
        {
            path: '/renew-trip/:hash',
            name: 'RenewTrip',
            component: RenewTrip
        },
        {
            path: 'first-time-flyer',
            name: 'FirstTimeFlyer',
            component: FirstTimeFlyer
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
    ]
}

const routes = [
    appPages,
    iframe
];

export default routes;
